/**
 * Port of `src/app/(dashboard)/no-access/page.tsx`.
 *
 * Markup copied verbatim. The only change is how `?page=` is read: an async
 * Server Component's `searchParams` promise becomes the `useSearchParams`
 * shim. The wording, the icon, the colours and the "Back to Dashboard" link
 * are untouched, so a denied user sees exactly the screen they see today.
 */
import { ShieldOff } from "lucide-react";
import Link from "@/compat/link";
import { useSearchParams } from "@/compat/navigation";

export function NoAccessPage() {
  const page = useSearchParams().get("page") ?? undefined;

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 dark:bg-red-950/30">
        <ShieldOff className="h-8 w-8 text-red-600 dark:text-red-400" />
      </div>
      <h1 className="mb-2 text-2xl font-bold text-[var(--cp-ink)]">No access</h1>
      <p className="mb-6 max-w-md text-sm text-[var(--cp-ink-2)]">
        Your account doesn&apos;t have permission to view{" "}
        <strong>{page ?? "this section"}</strong>. Ask an admin to grant access in Settings.
      </p>
      <Link
        href="/dashboard"
        className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Back to Dashboard
      </Link>
    </div>
  );
}
